import type { RouteRecordRaw } from 'vue-router';

export default {
  path: 'apis',
  name: 'api',
  component: () => import('@/views/dashboard/apis/root.vue'),
  redirect: () => ({ name: 'api/tokens' }),
  children: [
    {
      path: 'tokens',
      name: 'api/tokens',
      component: () => import('@/views/dashboard/apis/api.vue'),
    },
    {
      meta: { feature: 'buckets' },
      path: 'buckets-keys',
      name: 'api/buckets-keys',
      component: () => import('@/views/dashboard/apis/buckets-keys.vue'),
    },
  ],
} satisfies RouteRecordRaw;
